import { formatAmountAbs } from '@salaries/shared';

// Currency rendering — always dir="ltr" so the ₪ and minus sit on the correct
// side in RTL flow (guidelines 05 §2/§20). ILS-only for now.
export function Money({ value }: { value: number | null | undefined }) {
  if (value == null) return <span className="text-secondary-text">—</span>;
  const n = Number(value);
  const abs = formatAmountAbs(n);
  return <span dir="ltr">{n < 0 ? `-₪${abs}` : `₪${abs}`}</span>;
}

/** The same formatting as <Money>, as a plain string — for tooltips, aria-labels
 *  and other places that can't hold an element. */
export function formatMoney(value: number | null | undefined): string {
  if (value == null) return '—';
  const n = Number(value);
  const abs = formatAmountAbs(n);
  return n < 0 ? `-₪${abs}` : `₪${abs}`;
}

/** <Money> for an amount that can take money away (a קיזוז): a negative value
 *  in the error colour, the way the deduction and ניכוי במקור columns show it. */
export function SignedMoney({ value }: { value: number }) {
  return value < 0 ? (
    <span className="text-error-red">
      <Money value={value} />
    </span>
  ) : (
    <Money value={value} />
  );
}
